import { render, staticRenderFns } from "./SalesApprovalDetail.vue?vue&type=template&id=25c44610&scoped=true"
import script from "./SalesApprovalDetail.vue?vue&type=script&lang=js"
export * from "./SalesApprovalDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c44610",
  null
  
)

export default component.exports